module.exports = __webpack_public_path__ + "static/GT-Super-Text-Bold-8475eb7c457417b909f43bf9c12d94b5.woff";